import React from 'react';
import Lottie from 'lottie-react';
import loadingAnimation from '../animations/loading-animation.json';
import emptyAnimation from '../animations/empty-animation.json';

export function LoadingState() {
    return (
        <div className="loading-container">
            <div className="loading-icon"> {/* Fixed typo: "laoding-icon" -> "loading-icon" */}
                <Lottie animationData={loadingAnimation} loop={true} />
            </div>
            <h3>Memuat Berita...</h3> {/* Removed inline style, handled by CSS */}
            <p>Sedang mengumpulkan informasi terkini</p>
        </div>
    );
}

export function EmptyState({ searchTerm, setSearchTerm }) {
    return (
        <div className="empty-state">
            {searchTerm ? (
                <>
                    <div className="empty-search-container">
                        <div className="empty-search-icon">
                            <Lottie animationData={emptyAnimation} loop={true} />
                        </div>
                        <h2>Tidak ada hasil</h2>
                        <p>Tidak ada berita yang cocok dengan "{searchTerm}"</p>
                        <button className="reset-search" onClick={() => setSearchTerm('')}>
                            Reset Pencarian
                        </button>
                    </div>
                </>
            ) : (
                <>
                    <div className="empty-search-container">
                        <div className="empty-search-icon">
                            <Lottie animationData={emptyAnimation} loop={true} />
                        </div>
                        <h2>Tidak Ada Berita Tersedia</h2>
                        <p>Silakan coba muat ulang atau periksa koneksi internet Anda.</p>
                    </div>
                </>
            )}
        </div>
    );
}